// Default concentration options — the bottles most commonly on a shelf, not a
// fixed list: Settings can remove or edit any of them (see hiddenDefaults).
export const DEFAULT_CONCENTRATIONS = {
  paracetamol: ['100/1', '120/5', '160/5', '250/5'],
  ibuprofen: ['100/5', '200/5', '400/10'],
  other: []
};

// The synced concentrations payload is `{ paracetamol: [...], ibuprofen: [...] }`
// of *added* strengths, plus an optional `hiddenDefaults` map of built-ins the
// user removed.
//
// Removing a built-in is recorded as a hide rather than by rewriting the list
// into an explicit one, because the payload is shared with the other phone: a
// phone still on an older version reads its medicines' arrays exactly as
// before, ignores the extra key, and carries it through untouched when it saves
// its own change. Rewriting the shape would have made an old client read
// "custom additions" as "the whole list" and silently lose the built-ins.
//
// Editing a built-in is a hide plus an addition, so an edited strength moves to
// the end of the list — and "Restore removed" always brings back exactly the
// originals.
export const hiddenDefaultsFor = (custom, med) => (custom && custom.hiddenDefaults && custom.hiddenDefaults[med]) || [];
export const concentrationsFor = (custom, med) => {
  const hidden = hiddenDefaultsFor(custom, med);
  return [
    ...(DEFAULT_CONCENTRATIONS[med] || []).filter(c => !hidden.includes(c)),
    ...((custom && custom[med]) || []),
  ];
};

// Parses the "100 mg/5 ml" display string a dose entry stores its concentration
// as (distinct from parseConcentration's "100/5" input format), so an edited
// dose can recompute mgTotal at the same ratio.
export const parseStoredConcentration = (str) => {
  const m = /^([\d.]+)\s*mg\/([\d.]+)\s*ml$/.exec(str || '');
  return m ? { mg: parseFloat(m[1]), ml: parseFloat(m[2]) } : null;
};
